export default __webpack_public_path__ + "static/IBMPlexSans-Bold-Cyrillic-8da4002b6b9aeb7242879c94d18fda83.woff2";